import React from "react";
// @ts-ignore
import imgs from "./../Assets/Images/empty_illustration.svg";

export default function EmptyPage() {
  return (
    <div className="text-center mt-5">
      <p className="fw-bold mt-5 font-31">
        It Seems you don't have any favourite videos yet!
      </p>
      <img
        src={imgs}
        className="my-5 text-center"
        width={300}
        height={300}
        alt="img"
      />
    </div>
  );
}
